import React from "react";
import "./stakeholders.css";
import {Distributor } from "../components";
import "./../App.css";
const Distributor_page = () => {
  return (
    <div>
      <Distributor />
    </div>
  );
};

export default Distributor_page;
